import ApiClient from '~/ApiClient';

import mapReferenceBasketVersion from './mapReferenceBasketVersion';
import ReferenceBasketVersion from './ReferenceBasketVersion';

export interface Result {
	items: ReferenceBasketVersion[];
}

export default async function findReferenceBasketVersions(client: ApiClient): Promise<Result> {
	const request = await client.fetch('sk-price-referencing/max-price/reference-basket-versions');
	const response = await request.json();
	return { items: response.items.map(mapReferenceBasketVersion) };
}
